import reporter from "../report/reporter";
import { getPage, getSearch } from "../shared/global";
import { getAttribute } from "./get";

const sourceMap = {
  top_new: "吸顶",
  discovery_material_top: "横幅",
  discovery_waterfall_fixed_1: "固定1",
  discovery_waterfall_fixed_2: "固定2",
  discovery_waterfall_random_1: "随机1",
  search_waterfall_fixed_1: "固定1",
  search_waterfall_fixed_2: "固定2",
  search_waterfall_random_1: "随机1",
};

function getTrackData(target, type) {
  const page = getPage();
  const trackData = {
    ...(type === "expose"
      ? { event_id: 35001, event_name: "resource_loc_expose" }
      : { event_id: 35002, event_name: "resource_loc_click" }),
    ...page,
    resource_type: getAttribute(target, "data-resource-type") || "",
    resource_id: getAttribute(target, "data-resource-id"),
    resource_title: getAttribute(target, "data-resource-title"),
    subject_name: getAttribute(target, "data-subject-name") || undefined,
    plan_id: getAttribute(target, "data-plan-id") || undefined,
    plan_name: getAttribute(target, "data-plan-name") || undefined,
  };

  const { page_nm, sub_page_nm } = page;

  var source = getAttribute(target, "data-content-source");

  if (source) {
    trackData.resource_source = `${page_nm}_${sub_page_nm || ""}_${
      sourceMap[source] || source
    }`;
  } else {
    trackData.resource_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    const input = document.getElementById("hb_search_input");
    trackData.search_word = input?.value;
    trackData.search_word_type = getSearch().search_word_type;
    trackData.filter_ids = getSearch().filter_ids || [];
  }

  const item_location = getAttribute(target, "data-item-location");
  if (item_location) {
    trackData.item_location = item_location;
  }

  const resource_function = getAttribute(target, "data-resource-func");
  if (resource_function) {
    trackData.resource_function = resource_function;
  }

  const resource_location = getAttribute(target, "data-resource-location");
  if (resource_location) {
    trackData.resource_location = resource_location;
  }

  return trackData;
}

export function resource_loc_expose(target) {
  const trackData = getTrackData(target, "expose");
  reporter(trackData);
}

export function resource_loc_click(target) {
  const trackData = getTrackData(target, "click");
  reporter(trackData);
}
